const modifiedFields = ['widgetName','eventStateModel'];
const modifiedFieldCustom = {};
const sortByFields = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };